export default "__VITE_ASSET__IDuFNpj9__"